import React from 'react';
import {
  Box,
  Typography,
  Modal,
  Button,
} from '@mui/material';

function TooltipModal({ open, handleClose, transactionDetails }) {

  if (!transactionDetails) return null; // Prevent rendering if no data

  const formatDateString = (dateStr) => {
    if (!dateStr) return "N/A";
    const dt = new Date(dateStr);
    return dt.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="wallet-details-modal-title"
      aria-describedby="wallet-details-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '70%', sm: '400px' },
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: '8px',
          maxHeight: '80vh',
          overflowY: 'auto',
          overflow: 'hidden',
        }}
      >
        {/* LOCKED watermark */}
        {transactionDetails.pointHistoryStatus === 'locked' && (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%) rotate(-30deg)',
              fontSize: '72px',
              fontWeight: 900,
              color: 'rgba(124, 58, 237, 0.10)',
              pointerEvents: 'none',
              userSelect: 'none',
              whiteSpace: 'nowrap',
              letterSpacing: '6px',
              zIndex: 0,
              lineHeight: 1,
            }}
          >
            🔒 LOCKED
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            mb: 2,
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Box>
            <Typography
              id="wallet-details-modal-title"
              variant="h6"
              component="h2"
              sx={{
                fontWeight: 'bold',
                fontSize: { xs: '2.5rem', sm: '2rem' },
              }}
            >
              Transaction Details
            </Typography>
            {transactionDetails.pointHistoryStatus === 'locked' && (
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  mt: 0.5,
                  px: 1.5,
                  py: 0.4,
                  borderRadius: '999px',
                  bgcolor: 'rgba(124, 58, 237, 0.10)',
                  border: '1px solid rgba(124, 58, 237, 0.25)',
                  color: '#6d28d9',
                  fontSize: { xs: '1.4rem', sm: '1.2rem' },
                  fontWeight: 700,
                }}
              >
                🔒 This transaction is locked
              </Box>
            )}
          </Box>

          {/* {transactionDetails.rewardType && (
            <Typography
              sx={{
                textAlign: 'right',
                fontSize: { xs: '2rem', sm: '2rem' }, // mobile ~11px, desktop ~13px
                backgroundColor: '#1669F2',
                color: '#FFFFFF',
                p: 0.5,
                borderRadius: '10px',
                fontWeight: '500',
                display: 'inline-block',
                textTransform: 'uppercase',
              }}
            >
              {transactionDetails.rewardType.replace(/_/g, ' ')}
            </Typography>
          )} */}
        </Box>

        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Typography sx={{ mb: 1, fontSize: { xs: '2rem', sm: '2rem' } }}>
            <strong>Project Name:</strong> {transactionDetails.projectName || "N/A"}
          </Typography>

          {transactionDetails.wing && (
            <Typography sx={{ mb: 1, fontSize: {xs: '2rem', sm: '2rem' } }}>
              <strong>Wing Name:</strong> {transactionDetails.wing}
            </Typography>
          )}

          {transactionDetails.unitId && (
            <Typography sx={{ mb: 1, fontSize: {xs: '2rem', sm: '2rem' } }}>
              <strong>Unit Number:</strong> {transactionDetails.unitId}
            </Typography>
          )}

          {(transactionDetails.rewardType === 'fos_basic' ||
            transactionDetails.rewardType === 'fos_incentive') &&
            transactionDetails.agreementRankInQuarter != null && (
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  mb: 1.5,
                  px: 1.5,
                  py: 0.4,
                  borderRadius: '999px',
                  bgcolor: 'rgba(22, 105, 242, 0.10)',
                  border: '1px solid rgba(22, 105, 242, 0.25)',
                  color: '#1669f2',
                  fontSize: { xs: '1.6rem', sm: '1.3rem' },
                  fontWeight: 700,
                }}
              >
                Agreement #{transactionDetails.agreementRankInQuarter} this quarter
              </Box>
          )}

          {transactionDetails.rewardType === 'fos_site_visit' &&
            transactionDetails.siteVisitRankInProject != null && (
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  mb: 1.5,
                  px: 1.5,
                  py: 0.4,
                  borderRadius: '999px',
                  bgcolor: 'rgba(5, 150, 105, 0.10)',
                  border: '1px solid rgba(5, 150, 105, 0.25)',
                  color: '#047857',
                  fontSize: { xs: '1.6rem', sm: '1.3rem' },
                  fontWeight: 700,
                }}
              >
                Site Visit #{transactionDetails.siteVisitRankInProject} for this project
              </Box>
          )}

          {transactionDetails.payeeVA && (
            <Typography sx={{ mb: 1, fontSize: { xs: '2rem', sm: '2rem'  } }}>
              <strong>Payee Virtual Account:</strong> {transactionDetails.payeeVA}
            </Typography>
          )}

          {transactionDetails.description && (
            <Typography sx={{ mb: 1, fontSize: { xs: '2rem', sm: '2rem' } }}>
              <strong>Description:</strong> {transactionDetails.description}
            </Typography>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button
              onClick={handleClose}
              sx={{
                backgroundColor: '#1669f2',
                color: '#FFFFFF',
                textTransform: 'none',
                fontSize: { xs: '2rem', sm: '1.5rem' },
                '&:hover': { backgroundColor: '#1257cc' },
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default TooltipModal;
